import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import Link from "next/link";
import { FC } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Image from "@/components/ui/Image/Image";
import { StorytellingCard } from "@/types";

const StorytellingCarouselCard: FC<StorytellingCard> = ({ image, logo, title, cta }) => {
  const locale = useLocale();
  return (
    <>
      <div className="bg-gold-20 relative overflow-hidden aspect-3-2 rounded-md">
        <div className="relative">
          <Image className="w-full object-cover aspect-3-2" src={image.url} alt={image.title || image.description || ""} width={703} height={482} />
          <div className="absolute w-full h-full top-0 left-0 inset-0 img-overlay-3"></div>
        </div>
        <div className="absolute flex flex-row justify-between md:flex-col md:items-center w-full gap-xs pb-m md:left-2/4 md:-translate-x-1/2">
          {logo && (
            <div className="pl-m md:pl-0">
              <Image src={logo.url} width={142} height={80} alt={logo.title || logo.description || ""} className="mx-auto w-[142px] h-[80px]" />
            </div>
          )}
          {cta && (
            <div className="flex flex-col justify-end pb-m">
              <Link href={getLink(cta, locale)} target={cta.link?.target ? "_blank" : "_self"}>
                <Button
                  size={ButtonSize.SMALL}
                  theme={ButtonTheme.WHITE}
                  customClass="pr-m py-m pb-0 md:pb-m md:pt-0"
                  type="button"
                  variant={ButtonVariant.TERTIARY}
                >
                  {cta.label}
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default StorytellingCarouselCard;
